var Handlebars = require('handlebars-template-loader/runtime');

Handlebars.registerHelper('index_of', function (context, ndx) {
    if (context) {
        return context[ndx];
    }

    return ndx;
});